"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailFromTypes = {
    None: 0,
    Customer: 1,
    User: 2
};
